import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardActions,
  Button,
  Grid,
  Alert,
} from "@mui/material";

const API = process.env.REACT_APP_API_URL;

export default function PostReview() {
  const [pendingPosts, setPendingPosts] = useState([]);
  const [alert, setAlert] = useState({ message: "", severity: "" });

  useEffect(() => {
    fetch(`${API}/pendingPosts`)
      .then((res) => res.json())
      .then((data) => setPendingPosts(data))
      .catch((err) => {
        console.error("Fetch error:", err);
        setAlert({ message: "Failed to fetch posts.", severity: "error" });
      });
  }, []);

  const approvePost = async (id) => {
    try {
      const res = await fetch(`${API}/pendingPosts/approve/${id}`, {
        method: "POST",
      });
      if (res.ok) {
        setAlert({ message: "Post approved!", severity: "success" });
        setPendingPosts(pendingPosts.filter((p) => p._id !== id));
      } else {
        const err = await res.json();
        setAlert({
          message: err.error || "Failed to approve.",
          severity: "error",
        });
      }
    } catch (err) {
      console.error("Approval error:", err);
      setAlert({ message: "Error approving post.", severity: "error" });
    }
  };

  const rejectPost = async (id) => {
    try {
      const res = await fetch(`${API}/pendingPosts/${id}`, {
        method: "DELETE",
      });
      if (res.ok) {
        setAlert({
          message: "Post rejected and deleted.",
          severity: "success",
        });
        setPendingPosts(pendingPosts.filter((p) => p._id !== id));
      } else {
        const err = await res.json();
        setAlert({
          message: err.error || "Failed to delete.",
          severity: "error",
        });
      }
    } catch (err) {
      console.error("Rejection error:", err);
      setAlert({ message: "Error rejecting post.", severity: "error" });
    }
  };

  return (
    <Box py={2}>
      <Typography
        variant="h3"
        fontWeight="bold"
        color="black"
        textAlign="center"
        gutterBottom
      >
        PENDING POSTS
      </Typography>

      {alert.message && (
        <Alert severity={alert.severity} sx={{ mb: 3 }}>
          {alert.message}
        </Alert>
      )}

      <Grid container spacing={3}>
        {pendingPosts.map((post) => (
          <Grid item xs={12} md={6} key={post._id}>
            <Card>
              <CardContent>
                <Typography variant="h6">{post.title}</Typography>
                <Typography variant="subtitle2" color="textSecondary">
                  {post.subtitle}
                </Typography>

                {post.imageUrls?.length > 0 && (
                  <Box mt={2}>
                    <img
                      src={post.imageUrls[0]}
                      alt="preview"
                      style={{ width: "100%", borderRadius: "8px" }}
                    />
                  </Box>
                )}
              </CardContent>

              <CardActions>
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => approvePost(post._id)}
                >
                  Approve
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => rejectPost(post._id)}
                >
                  Reject
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
